<template>
    <div class="container">
        <div class="meet-header trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />
        </div>
        <div class="content">
            <div class="jb-head">
                <img
                    :src="this.guest.image[0].url"
                    alt=""
                />

                <h2 class="tit">{{this.guest.name}}</h2>
            </div>
            <div class="jb-info">
               {{this.guest.introduction}}
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";
export default {
    components: {
        meetHeader,
    },
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "嘉宾介绍",
            },
            guest:{}
        };
    },
    async created() {
    if (this.$route.params.guest) {
        this.guest = this.$route.params.guest
      } else if (this.$route.query.guest_id) {
        this.guest = await this.getList({id: this.$route.query.guest_id})
      }

    },
    methods: {
        handleClickIocn() {
            history.go(-1);
        },
       async getList(filters) {
            const url = process.env.VUE_APP_API_URL + "api/v1/confguestintro"
            if (!filters.per_page || filters.per_page == "") {
            filters.per_page = -1
            }
            return axios.get(url, { params: filters }).then((res) => {
            
                return res.data.results[0]
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.jb-head {
    width: 100%;

    img {
       height: 80%;
        width: 80%;
        margin-left: 30px;
    }

    .tit {
        line-height: 50px;
        text-align: center;
    }
}

.jb-info {
    margin-top: 15px;
    font-size: 14px;
    padding: 0 15px;
    color: #424242;
    line-height: 28px;
}
</style>